var moment = require('moment');
module.exports = function(angularModule) {
  angularModule.controller(
    'providerJobStatusDetailController',
    function providerJobStatusSummaryController($scope, $log, $stateParams, $state, providerJobStatusService) {

      $scope.loading = true;
      $scope.jobTypes = providerJobStatusService.jobTypes;
      $scope.provider = $stateParams.provider;
      $scope.offset = Number($stateParams.offset) || 0;
      $scope.periodType = $stateParams.periodType || 'day';

      $scope.onUpdateTimePeriod = function (periodType, offset) {
        $state.go('.', { periodType, offset });
      };

      $scope.goToSummary = function() {
        $state.go('^.summary', $stateParams);
      };


      function setStatusItems(data) {
        var display = data.details.map(function (detail) {
          return {
            start: new Date(detail.start),
            end: new Date(detail.end),
            titleCell: moment(detail.start).format('lll'),
            columns: providerJobStatusService.buildColumnsFromUnorderedStatusItems(detail.byProvider[$stateParams.provider])
          }
        });

        $scope.dateRangeRows =  _.sortBy(display, function(detail) {
          return detail.start.getTime() * -1;
        });
      }

      providerJobStatusService.getStatusForPeriod({ periodType: $scope.periodType, offset: $scope.offset }).then(function(resp) {
        $scope.loading = false;
        setStatusItems(resp.data);
      });
    });

}
